import React from 'react';
import GCEInstruction from './GCEInstruction';
import { ExamType } from '../../../../api/candidate/exam/model';
import PsleInstruction from './PsleInstruction';
import IpsleInstruction from './IpsleIntruction';

const ExamInstruction = (props: { examType: string }) => {
  const { examType } = props;

  if (examType === 'PSLE') {
    return <PsleInstruction />;
  }

  if (examType === ExamType.GCE) {
    return <GCEInstruction />;
  }

  if (examType === 'Non-National') {
    return <GCEInstruction />;
  }

  if (examType === ExamType.IPSLE) {
    return <IpsleInstruction />;
  }

  return <GCEInstruction />;
};

export default ExamInstruction;
